import styled from "styled-components";
import { Table } from "antd";

interface IProps {
    active?: boolean;
    disabled?: boolean;
}

export const SettingsContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: ${({ disabled, active }: IProps) =>
        disabled ? "#62936126" : active ? "#629361" : "#FFFFFF"};
    height: 100%;
    cursor: ${({ disabled }: IProps) =>
        disabled ? "not-allowed" : "pointer"} !important;
    * {
        cursor: ${({ disabled }: IProps) =>
            disabled ? "not-allowed" : "pointer"} !important;
    }
`;

export const SettingsMenu = styled.div<{
    active: boolean;
    settingsPosition?;
}>`
    position: absolute;
    padding: 15px 30px 24px 20px;
    z-index: 2;
    top: 0;
    ${({ settingsPosition }) =>
        settingsPosition === "right" ? "left:45px;" : "left: -225px;"}
    ${({ active }) => (active ? "" : "display:none;")}
    width: 225px;
    min-height: 68px;
    transition: all 0.3s;
    background: #629361;
    ${({ settingsPosition }) =>
        settingsPosition === "right"
            ? "border-radius: 0 10px 10px 10px;"
            : "border-radius: 10px 0 10px 10px;"}

    border-color: ${({ active }) => (active ? "none" : "none")};
`;

export const SettingsItems = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
`;

export const SettingItem = styled.div`
    position: relative;
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;

    :nth-child(n + 2) {
        margin-top: 18px;
    }

    ::after {
        position: absolute;
        content: "";
        bottom: -9px;
        left: 0;
        width: 180px;
        height: 2px;
        background-color: #7cbe7b;
    }
`;

export const MyTable = styled(Table)`
    box-shadow: 0 0 5px rgba(49, 69, 49, 0.14);
    border-radius: 10px;
    width: 100%;
    height: 100%;
    background: #ffffff;
    user-select: none;

    thead > tr > th {
        padding: 10px;
        background: white;
        font-weight: 600;
        text-transform: capitalize;
        user-select: none;
    }

    thead > tr > th:nth-last-child(2) {
        padding: 0 !important;
        cursor: pointer;
    }

    thead > tr > th:nth-last-child(2) > div {
        width: 100%;
        height: 43px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    thead tr th:last-child {
        padding: 0;
        max-width: 20px;
    }

    tbody tr td {
        vertical-align: middle;
        height: 42px;
        padding: 9px 15px;
        user-select: none;
    }

    .ant-table-cell-fix-right {
        background-color: white;
        z-index: 0;
    }

    & .ant-table-body {
        overflow: auto !important;
    }

    & * {
        scrollbar-color: #7cbe7b transparent; /* «цвет ползунка» «цвет полосы скроллбара» */
        scrollbar-width: thin;

        /* полоса прокрутки (скроллбар) */

        ::-webkit-scrollbar {
            width: 8px; /* ширина для вертикального скролла */
            height: 8px; /* высота для горизонтального скролла */
            background-color: transparent;
        }

        /* ползунок скроллбара */

        ::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #7cbe7b;
        }
    }

    > .ant-spin-nested-loading {
        height: 100%;

        > .ant-spin-container {
            height: 100%;

            > div {
                height: 100%;

                > div {
                    height: 100%;
                    z-index: 2;

                    > .ant-table-body {
                        z-index: 1;
                        max-height: 0;
                    }
                }
            }
        }
    }
`;

export const MenuContainer = styled.div<{ isOpen: boolean }>`
    width: 100%;
    height: 100%;
    background: ${({ isOpen }) => (isOpen ? "#629361" : "white")};
    transition: background 0.2s linear;
    z-index: 0 !important;
`;

export const TableWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;
